jQuery(function(){
  const $ = jQuery,
        elWindow = $(window)
  		elBody = $('body');
  
  //
  const updateScrollState = () => {
    if (elWindow.scrollTop() == 0) {
    	elBody.addClass('not-scrolled');
    } else {
      elBody.removeClass('not-scrolled');
    }
  };
  //
  updateScrollState();
  elWindow.on('scroll', updateScrollState);
  
  /*--- Related Products Fix ---*/
  // a REALLY BAD fix, but "globo.alsobought" sucks so...
  const _fixGabSizes = function () {
    if ($('#ga-product_related').length == 0) {
      setTimeout(_fixGabSizes, 1000);
    } else {
      $('#ga-product_related .ga-product .info-sizes[data-sizes]').each(function(){
        const options = $(this).data('sizes').toString().toUpperCase().split(',');
        let html = '';
        eeSortSizes(options, '|', window.globoSizesMap).forEach(fItem => {
          html += '<span>' + fItem + '</span>';
        });
        $(this).html(html);
      });
    }
  };
  if (window.globoSizesMap && $('body.template-product').length > 0 && $('#globoRelatedProductsTemplate').length > 0) {
    _fixGabSizes();
  }

});


/**
 * Returns the given array of sizes[string] sorted based on our map
 * @param {Array} pSizes array of string sizes to sort
 * @param {string} pSep (optional) string separator used in the map
 * @param {string} pMap (optional) sorting map to use instead of the global one
 * @returns {Array} sorted sizes
*/
const eeSortSizes = (pSizes, pSep = ',', pMap = '') => {
  let map,
    unmappedSizes = '';

  if (typeof pMap == 'string' && pMap.replace(/ /g, '') != '') {
    map = pMap;
  } else if (typeof window.eeSizesMap == 'string' && window.eeSizesMap.replace(/ /g, '') != '') {
    map = window.eeSizesMap;
  }

  if (!map || typeof pSizes != 'object' || typeof pSizes.length != 'number' || pSizes.length == 0) {
    return [];
  }

  // sanitizing
  pSizes = pSizes
    .map(fSize => fSize
      .toString().toUpperCase()
      .replace(',', '.')
      .replace(' 1/2', '½').replace(' 1/3', '⅓').replace(' 2/3', '⅔')
    )
    .sort();

  // append natural sorted sizes that are not available on Map but in-stock
  pSizes.forEach(fVal => {
    fVal = fVal.split('/')[0]; // for sizes like "S/40"
    if (map.indexOf(fVal) == -1 && map.indexOf(fVal) == -1) {
      unmappedSizes += pSep + fVal;
    }
  });
  map = map.split(pSep);
  if (unmappedSizes != '') {
    map = map.concat(unmappedSizes.split(pSep).sort());
  }

  // re-ordering
  pSizes.sort((fA, fB) => {
    fA = map.indexOf(fA.split('/')[0]);
    fB = map.indexOf(fB.split('/')[0]);
    if (fB == -1) {
      return -1;
    } else if (fA == -1) {
      return 1;
    } else if (fB != fA) {
      return fA - fB
    }
    return 0;
  });

  return pSizes;
};


function openSearch() {
  const overlay = document.querySelector('.boost-pfs-search-suggestion-mobile-overlay');
  const panel = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');
  const body = document.querySelector('body');

  overlay.style.display = 'block';
  panel.style.display = 'block';

  body.classList.toggle('boost-pfs-search-suggestion-mobile-open');
}